// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"projects_front_src_app_modules_doc-guardian-module_doc-guardian-module_module_ts":"8dcab65b1726c2c7","projects_front_src_app_modules_record-detail-module_record-detail-module_module_ts":"b87d450b10bded6a"}[chunkId] + ".js";
};